export default __webpack_public_path__ + "static/media/cisius_1.ddd7822a.png";